import { NotFound, Wrapper } from '@cma/common'
import { ReportHeader, useReport } from '@cma/features/report'
import { Helmet } from 'react-helmet-async'
import { useParams } from 'react-router-dom'

export default function PropertyPublish() {
  const { id } = useParams()
  const { data: { report } = {} } = useReport({ id: id as string })

  if (!report) {
    return (
      <Wrapper>
        <NotFound />
      </Wrapper>
    )
  }

  return (
    <Wrapper>
      <Helmet>
        <title>Publish Report - Property - Cloud CMA</title>
      </Helmet>
      <ReportHeader
        reportId={report.id}
        title="Publish Report"
        breadcrumbs={[
          { title: 'Criteria', url: `/properties/${id}/edit` },
          { title: 'Listings', url: `/properties/${id}` },
          { title: 'Customize', url: `/properties/${id}/customize` },
          { title: 'Publish', url: `/properties/${id}/publish`, publish: true }
        ]}
      />
      <main>TODO</main>
    </Wrapper>
  )
}
